const operationsReadModelComponentLoaders = Object.freeze({
  'operations-read-model.reservation-list-workspace': async () => {
    const module = await import('./reservation-list-workspace-component.js');
    return module.ReservationListWorkspaceComponent;
  },
  'operations-read-model.dashboard-workspace': async () => {
    const module = await import('./operations-dashboard-component.js');
    return module.OperationsDashboardComponent;
  },
});

export default operationsReadModelComponentLoaders;
